export const setup = () => {
  const enabled = CONFIG.rollbar.enabled
  if (!enabled) {
    console.log('Rollbar disabled due to config')
  }

  if (typeof Rollbar === 'undefined') {
    console.log('Rollbar instance not found')
    return
  }

  Rollbar.configure({
    enabled,
    hostSafeList: CONFIG.rollbar.scriptDomains,
    ignoredMessages: CONFIG.rollbar.ignoredMessages
  })
  Rollbar.global({
    itemsPerMinute: CONFIG.rollbar.itemsPerMinute
  })
}

export const setUser = user => {
  if (typeof Rollbar === 'undefined') {
    console.log('Rollbar instance not found')
    return
  }

  Rollbar.configure({
    payload: {
      person: {
        id: user.slug,
        username: user.name,
        email: user.email
      }
    }
  })
}

export const handlePageChange = location => {
  if (typeof Rollbar === 'undefined') {
    console.log('Rollbar instance not found')
    return
  }

  Rollbar.configure({
    payload: {
      context: location.pathname
    }
  })
}
